import styled from "styled-components";

const HeaderStyled = styled.nav`
  width: 100%;
  height: 2rem;
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  padding: 1.5rem;
  font-weight: 700;
`;
export default HeaderStyled;
